<template>
  <div class="layers-panel">
    <ZoomCenterTransition>
      <i
        v-if="!showPanel"
        class="material-icons trigger-button smooth-shadow"
        @click="showPanel = true"
        >layers</i
      >
    </ZoomCenterTransition>
    <SlideXLeftTransition>
      <div v-if="showPanel" class="panel smooth-shadow">
        <div class="panel-header smooth-shadow">
          <Spinner v-if="isRequestInProgress" small />
          <icon v-else size="18">layers</icon>
          <h3 class="mar-left-10">Layers</h3>
          <expand />
          <icon type="button" size="18" @click="showPanel = false">clear</icon>
        </div>
        <!-- <div v-if="getMode === 'EDIT'" class="panel-add-button">
          <icon
            class="fly-icon add-layer-button smooth-shadow"
            @click="showAddLayerPopup = true"
            >add</icon
          >
        </div> -->
        <simplebar class="panel-body-wrapper" data-auto-hide="true">
          <div class="panel-body">
            <LayerGroup layerType="Demand" :layers="getDemandLayers" />
            <LayerGroup layerType="Supply" :layers="getSupplyLayers" />

            <div
              v-if="getDemandLayers.length + getSupplyLayers.length === 0"
              class="no-content-image"
            >
              <img src="@/assets/dashboard_created.svg" class="image" />
              <p>
                No Layers found. Click on <strong>+</strong> to start
                visualizing your data.
              </p>
            </div>
          </div>
        </simplebar>
      </div>
    </SlideXLeftTransition>
  </div>
</template>

<script>
import { ZoomCenterTransition, SlideXLeftTransition } from "vue2-transitions";
import LayerGroup from "@/components/supply_demand_gap/views/LayerGroup";
import { mapGetters } from "vuex";

export default {
  components: {
    ZoomCenterTransition,
    SlideXLeftTransition,
    LayerGroup,
  },
  data() {
    return {
      showPanel: true,
      showAddLayerPopup: false,
      showAddEventTotalsPopup: false,
      showAddTimeSpentPopup: false,
      showEditEventTotalsPopup: false,
      showEditTimeSpentPopup: false,
      layerToEdit: null,
    };
  },
  computed: {
    ...mapGetters("SupplyDemand", [
      "getDemandLayers",
      "getSupplyLayers",
      "getMode",
    ]),
    ...mapGetters("Data", ["isRequestInProgress"]),
  },
  methods: {},
  watch: {},
};
</script>

<style lang="scss" scoped>
.layers-panel {
  position: absolute;
  top: 12px;
  left: 12px;
  z-index: 99;

  .trigger-button {
    padding: 10px;
    background: var(--color-secondary);
    border-radius: 50%;
    transition: 0.1s all ease-in-out;

    &:hover {
      color: var(--color-primary);
      cursor: pointer;
    }

    &:active {
      transform: scale(0.9);
    }
  }

  .panel {
    width: 300px;
    height: 55vh;
    background: var(--color-default-background);
    position: absolute;
    top: 0;
    display: flex;
    flex-direction: column;
    border-radius: 5px;
    overflow: hidden; // So that simplebar doesn't obstruct the map.

    .panel-header {
      display: flex;
      flex-direction: row;
      align-items: center;
      border-radius: 5px 5px 0 0;
      background: var(--color-secondary);
      padding: 7px 5px 7px 15px;
    }

    .panel-body-wrapper {
      /* THIS WORKS: */
      flex: 1;
      min-height: 5px;

      .panel-body {
        padding: 10px 10px 35px 10px;
        /* overflow: auto; */

        .no-content-image {
          display: flex;
          flex-direction: column;
          padding: 15px;
          justify-content: center;
          align-items: center;

          .image {
            height: 200px;
            width: auto;
          }
          p {
            margin: 0;
            opacity: 0.7;
            margin-top: 20px;
            text-align: center;
          }
        }
      }
    }

    .panel-add-button {
      position: absolute;
      z-index: 100;
      right: 15px;
      bottom: 15px;

      .add-layer-button {
        cursor: pointer;
        transition: 0.2s all ease-in-out;
        background: var(--color-primary);
        color: var(--color-secondary);

        &:active {
          transform: scale(0.85);
        }
      }
    }
  }
}
</style>
